/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
     <br>
  <div>
  <div class="formPosition">

    <!-- ================================== Actualização de dados====================== -->

        <v-dialog v-model="dialog" max-width="800px">
           <v-container width="400px"  style="background-color:#006699; color:white; ">
      <div>
         <span>Edição de Fornecedor</span>
      </div>
  </v-container>
<v-form
    ref="form"
    v-model="valid"
    lazy-validation
>
      <v-card style="margin:auto;">
         <v-alert
          v-model="alert"
          dismissible
          :type="alertType"
          border="left"
          :icon="iconAlert"
          transition="scale-transition"
          :style="colorAlert"
          elevation="2"
          colored-border
        >
        {{msgAlert}}
      </v-alert>
        <v-card-text>
          <v-container>
            <v-row>
               <v-col cols="12" sm="6" md="8">
                 <v-text-field v-model="editedItem.nome" :rules="ruleRequired" label="Nome Completo" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="4">
                 <v-text-field v-model="editedItem.nif" :rules="ruleRequired" label="NIF" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="4">
                <v-select
                    :items="tipoFornecedores"
                    item-text="descricao"
                    item-value="descricao"
                    v-model="editedItem.tipoFornecedor"
                    :rules="ruleRequired"
                    filled
                    label="Tipo de Fornecedor"
                ></v-select>
              </v-col>
               <v-col cols="12" sm="6" md="4">
                 <v-text-field v-model="editedItem.morada" :rules="ruleRequired"  label="Morada" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="4">
                 <v-text-field v-model="editedItem.telefone1" :rules="ruleRequired" label="Telefone 1" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="4">
                 <v-text-field v-model="editedItem.telefone2" label="Telefone 2" ></v-text-field>
               </v-col>
                <v-col cols="12" sm="6" md="4">
                 <v-text-field v-model="editedItem.email" :rules="ruleRequired" label="Email" ></v-text-field>
               </v-col>
               <v-col cols="12" sm="6" md="8">
                 <v-text-field v-model="editedItem.Observacao" label="Observação" ></v-text-field>
               </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="color:white;" :disabled="!valid" color="green darken-1"   @click="Save()">Guardar</v-btn>
          <v-btn style="color:white;" :disabled="!valid" color="red darken-1"   @click="()=>dialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
</v-form>
        </v-dialog>
    <!-- ===================================================================================== -->

      <v-card style="margin:auto;" width="1200" >
        <v-card-title   style="background-color:#006699; color:white;"></v-card-title >
    <v-progress-linear
      v-if="progresso"
        indeterminate
        color="green"
        height="10"
      ></v-progress-linear>
      <v-card-title>
         <v-row>
           <v-col md="6"><span>Fornecedores</span></v-col>
            <v-col md="3">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Pesquisar pela referência do produto ou código de barra"
                single-line
                hide-details
              ></v-text-field>
           </v-col>
           <v-col md="2">
             <v-btn color="primary" @click="$router.push('Novo-Fornecedor')" style="margin-top:15px;">Novo Fornecedor <v-icon>add</v-icon></v-btn>
           </v-col>
         </v-row>
      </v-card-title>
        <template>
          <v-data-table :search="search" :headers="headers" :items="fornecedores">
           <template v-slot:item.action="{ item }">
                  <v-menu
                    :offset-x="offsetX"
                    :offset-y="offsetY"
                    bottom
                    origin="center center"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab dark small
                       color="#006699"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>menu</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item  @click="EditarFornecedor(item)">
                        <v-icon color="green">edit</v-icon>Editar
                      </v-list-item>
                    </v-list>
                  </v-menu>
              </template>
          </v-data-table>
        </template>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    offsetX: false,
    offsetY: true,
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    progresso: false,
    valid: true,
    menu: false,
    fornecedores: [],
    search: '',
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome do Cliente',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      { text: 'Nif', value: 'nif' },
      { text: 'Telefone', value: 'telefone1' },
      { text: 'Morada', value: 'morada' },
      { text: 'Tipo de Fornecedor', value: 'tipoFornecedor' },
      { text: 'Email', value: 'email' },
      { text: 'Action', value: 'action' }
    ],
    msg: '',
    editedItem: {
      email: '',
      morada: '',
      nif: '',
      nome: '',
      observacao: '',
      pkFornecedor: 0,
      telefone1: '',
      telefone2: '',
      tipoFornecedor: ''
    },
    tipoFornecedores:
    [
      { descricao: 'Muito Bom' },
      { descricao: 'Bom' },
      { descricao: 'Médio' }
    ]
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
  },

  methods: {
    async initialize () {
      try {
        this.progresso = true
        this.fornecedores = await axios
          .get('/FornecedorFindAll')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    EditarFornecedor (item) {
      this.editedItem = Object.assign(this.editedItem, item)
      this.dialog = true
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}

</style>
